<script>
import { getInboxClassByType, getInboxBrandColor } from 'dashboard/helper/inbox';

export default {
  props: {
    inbox: {
      type: Object,
      default: () => {},
    },
    showInboxIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedInboxClass() {
      const { phone_number: phoneNumber, channel_type: type } = this.inbox;
      const classByType = getInboxClassByType(type, phoneNumber);
      return classByType;
    },
    inboxBrandColor() {
      const { phone_number: phoneNumber, channel_type: type } = this.inbox;
      return getInboxBrandColor(type, phoneNumber);
    },
  },
};
</script>

<template>
  <div
    class="inbox--name inline-flex items-center py-0.5 px-0 leading-3 whitespace-nowrap bg-none text-n-gray-6 dark:text-slate-500 text-xs my-0"
  >
    <fluent-icon
      v-if="showInboxIcon"
      class="mr-0.5 rtl:ml-0.5 rtl:mr-0"
      :style="{ color: inboxBrandColor }"
      :icon="computedInboxClass"
      size="12"
    />
    {{ inbox.name }}
  </div>
</template>
